import { render, staticRenderFns } from "./RuleConfig.vue?vue&type=template&id=7cc670e0&scoped=true"
import script from "./RuleConfig.vue?vue&type=script&lang=js"
export * from "./RuleConfig.vue?vue&type=script&lang=js"
import style0 from "./RuleConfig.vue?vue&type=style&index=0&id=7cc670e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc670e0",
  null
  
)

export default component.exports